<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M21.872 24.663c.066-.004.133-.005.2-.003a5.083 5.083 0 10-.374-10.134 2 2 0 01-2.124-1.395c-1.084-3.49-4.004-5.8-7.237-5.8-4.054 0-7.667 3.69-7.667 8.666 0 4.976 3.613 8.666 7.667 8.666h9.535zm-9.535 2c-5.34 0-9.667-4.775-9.667-10.666S6.998 5.33 12.337 5.33c4.241 0 7.845 3.015 9.147 7.208a7.083 7.083 0 11.52 14.121v.004h-9.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsCloudOutline'
}
</script>
